import React from 'react'
import UIModal from 'components/Modal'
import ActionModal, { ActionIcon } from 'components/Modal/ActionModal'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import Markdown from 'react-markdown'

const CloseConfirmationModal = ({ onCancelClick }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <ActionModal
      cancelLabel={t('advertisements.edition.buttons.cancel')}
      confirmLabel={t('advertisements.edition.buttons.quit')}
      description={<Markdown>{t('advertisements.edition.modal.cancel_modal.message')}</Markdown>}
      icon={<i className="fa-light fa-xmark" />}
      onClose={onCancelClick}
      onConfirm={() => navigate({ pathname: '..' })}
      title={t('advertisements.edition.modal.cancel_modal.title')}
    />
  )
}

const HeaderModal = () => {
  const { id } = useParams()
  const { t } = useTranslation()
  return (
    <Box display="flex" gap={1.5} justifyContent="center" alignItems="center" width="100%" flex="1" height="64px" my="5px">
      <ActionIcon>
        <i className={`fa-regular fa-${id ? 'pen' : 'plus'}`} />
      </ActionIcon>
      <Typography
        sx={{
          fontSize: '20px',
          lineHeight: '30px',
          fontWeight: 600,
          color: 'content.primary',
          textTransform: 'capitalize'
        }}>
        {id ? t('advertisements.edition.modal.title') : t('advertisements.create.title')}
      </Typography>
    </Box>
  )
}


const Modal = ({
  children,
  onClose = () => { },
  onCloseConfirmation = null,
  showHeader = true,
}) => {
  if (onCloseConfirmation) {
    return <CloseConfirmationModal onCancelClick={onCloseConfirmation} />
  }

  return (
    <UIModal
      title=""
      maxWidth="min(700px, calc(100vw - 32px))"
      height="90vh"
      maxHeight="90vh"
      minWidth="min(700px, calc(100vw - 32px))"
      closeIconSx={{
        zIndex: 100,
        position: 'absolute',
        right: '30px',
        top: '16px'
      }}
      header={showHeader && HeaderModal}
      onClose={onClose}>
      {
        children
      }
    </UIModal>
  )
}

export default Modal
